<template>
  <div>
    <HappinessClasses
      v-if="['myskoolhappinessfoundation'].includes(reportDomain)"
    />
    <DepartmentAndClasses v-else />
  </div>
</template>

<script>
import HappinessClasses from "./HappinessClasses.vue";
import DepartmentAndClasses from "./departmentandclasses.vue";

export default {
  components: {
    HappinessClasses,
    DepartmentAndClasses,
  },
  data() {
    return {
      reportDomain: this.$store.state.report
        ? this.$store.state.report.replace(/_/g, "")
        : "",
    };
  },
};
</script>
<style></style>
